





































import { Provide, Prop, Component, Vue } from 'vue-property-decorator'
import { ReferralAPI } from '@/api/backend-client'
import { Referral } from '@/api/model/referral'
import { Contact } from '@/api/model/contact'
import { Company } from '@/api/model/company'
import { Branding } from '@/api/model/branding'
import { gsap } from 'gsap'
import color from 'color'

@Component
export default class FormAppraisalEnrich extends Vue {
    @Prop({ required: true }) readonly referralId!: string
    referral: Referral = null
    contact: Contact = null
    company: Company = null
    branding: Branding = null

    async mounted(): Promise<void> {
        await this.reloadData()
        await this.applyBranding()
    }

    @Provide()
    async reloadData(): Promise<void> {
        this.referral = null
        this.contact = null
        this.company = null
        this.branding = null

        this.referral = await ReferralAPI.get(this.referralId, true)
        this.contact = this.referral.contact
        this.company = this.referral.assignedToBranch.company
        this.branding = this.company.branding
    }

    async applyBranding(): Promise<void> {
        const primaryColor = color(this.branding.primaryColor).hsl()
        const hoverColor = primaryColor.lighten(.2)

        document.documentElement.style.setProperty('--primary', primaryColor.toString())
        document.documentElement.style.setProperty('--hover', hoverColor.toString())
    }

    animateShow(element: HTMLDivElement, onComplete: () => void) {
        gsap.set(element, {
            opacity: 0,
            translateX: 5,
        })

        gsap.to(element, {
            duration: .2,
            opacity: 1,
            translateX: 0,
            onComplete,
        })
    }

    animateHide(element: HTMLDivElement, onComplete: () => void) {
        gsap.to(element, {
            duration: .2,
            opacity: 0,
            translateX: -5,
            onComplete,
        })
    }

    get doneLoading(): boolean {
        return !!this.referral
            && !!this.contact
            && !!this.company
            && !!this.branding
    }
}
